import { MouseEvent as ReactMouseEvent, ReactNode } from "react"
import cn from "classnames"

import { Icon, Tooltip } from "components"
import { VIDEO_SIZE } from "modules/Call/common/constants"
import { Text } from "ui-kit/components-branded/index"

function Item({
    tooltipText,
    isActive,
    iconType,
    iconSize,
    onClickItem,
}: {
    tooltipText: ReactNode
    isActive: boolean
    iconType: "video-size-big" | "video-size-same" | "video-show" | "video-hide"
    iconSize: number
    onClickItem: (value: ReactMouseEvent<HTMLDivElement, MouseEvent>) => void
}) {
    return (
        <Tooltip
            className="change-video-toggle__tooltip"
            placement="top"
            overlay={<Text className="change-video-toggle__tooltip-text">{tooltipText}</Text>}
        >
            <div
                className={cn("change-video-toggle__item", {
                    "is-active": isActive,
                })}
                onClick={onClickItem}
            >
                <Icon type={iconType} size={iconSize} />
            </div>
        </Tooltip>
    )
}

export function ChangeVideoToggle({
    sizeVideo,
    onClickSizeVideo,
    isPsychotherapyMode,
    setIsPsychotherapyMode,
}: {
    sizeVideo: VIDEO_SIZE
    onClickSizeVideo: (value: VIDEO_SIZE) => void
    isPsychotherapyMode: boolean
    setIsPsychotherapyMode: (value: ReactMouseEvent<HTMLDivElement, MouseEvent>) => void
}) {
    return (
        <div className="change-video-toggle video-window-information is-hidden-mobile">
            <div className="change-video-toggle__sizes">
                <Item
                    tooltipText="Показывать собеседника крупно"
                    isActive={sizeVideo === VIDEO_SIZE.BIG}
                    iconType="video-size-big"
                    iconSize={16}
                    onClickItem={() => onClickSizeVideo(VIDEO_SIZE.BIG)}
                />

                <Item
                    tooltipText="Показывать меня и собеседника одинаково"
                    isActive={sizeVideo === VIDEO_SIZE.SAME}
                    iconType="video-size-same"
                    iconSize={20}
                    onClickItem={() => onClickSizeVideo(VIDEO_SIZE.SAME)}
                />
            </div>

            <Item
                tooltipText={
                    !isPsychotherapyMode ? (
                        <>
                            Включить режим психотерапии
                            <br />
                            (cкрыть свое избражение, собеседник продолжит вас видеть)
                        </>
                    ) : (
                        "Отключить режим психотерапии"
                    )
                }
                isActive={isPsychotherapyMode}
                iconType={!isPsychotherapyMode ? "video-hide" : "video-show"}
                iconSize={20}
                onClickItem={setIsPsychotherapyMode}
            />
        </div>
    )
}
